import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { style: {"max-width":"500px","margin":"0 auto"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        model: _ctx.formModel,
        onFinish: _ctx.onFinish,
        rules: _ctx.formRule,
        scrollToFirstError: true,
        layout: "vertical"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: _ctx.$t('labelText.username'),
            name: "username"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formModel.username,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formModel.username) = $event)),
                autofocus: true
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_a_form_item, {
            label: _ctx.$t('labelText.password'),
            name: "password"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_password, {
                value: _ctx.formModel.password,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formModel.password) = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_a_form_item, { name: "remember" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_checkbox, {
                checked: _ctx.formModel.remember,
                "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formModel.remember) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('labelText.rememberMe')), 1)
                ]),
                _: 1
              }, 8, ["checked"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                "html-type": "submit",
                block: "",
                loading: _ctx.isLoading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('text.login')), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "onFinish", "rules"]),
      _createVNode(_component_router_link, {
        to: { name: _ctx.RouteName.FORGOT_PASSWORD }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('text.forgotPassword')), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_a_divider, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('text.or')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            block: "",
            ghost: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                to: { name: _ctx.RouteName.REGISTER }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('text.regNewAcc')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}